import { useAction, useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { openDownloadDialogAction } from '@root/entities/deeplinking'
import { tradingPairAtom } from '@root/features/trade/trading/atoms'
import { isTauriOrBrowserLocalAtom } from '@root/shared'
import { useTranslation } from '@root/shared/localization'

type Props = {
  onCreateWallet: () => void
}

export const InstantTradeWalletsButton: React.FC<Props> = ({
  onCreateWallet,
}) => {
  const { t } = useTranslation()

  const openDownloadDialog = useAction(openDownloadDialogAction)
  const [tradingPair] = useAtom(tradingPairAtom)
  const [isTauri] = useAtom(isTauriOrBrowserLocalAtom)

  const handleOpenWallet = () => {
    if (isTauri) {
      onCreateWallet()
    } else {
      openDownloadDialog({
        pair: tradingPair
          ? {
              address: tradingPair.address,
              network: tradingPair.network,
            }
          : undefined,
      })
    }
  }

  return (
    <Root onClick={handleOpenWallet} size="xs" color="primary" radius="rounded">
      {t(isTauri ? 'wallet.open_wallet' : 'common.open_app')}
    </Root>
  )
}

const Root = styled(Button)`
  height: 28px;
  font-weight: 500;
`
